import { useTranslation } from 'react-i18next';
import type { TransferToTeamSubmitPayload } from 'v5/patterns/forms/dialogs/TransferToTeamDialogContent';
import { MountElementProps } from 'v5/messages/mount-element';
import { TransferToTeamDialog } from 'v5/patterns/forms/dialogs/TransferToTeamDialog';
import { WithServices } from 'v5/platform/ts/services';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';

export type TransferCallsheetDialogProps = MountElementProps &
  WithServices<[WithEnterpriseService]> & {
    organizationId: string;
    callsheetName: string;
    callsheetCount?: number;
    currentWorkspaceId?: number | null;
    currentTeamId?: number | null;
    onSubmit: (payload: TransferToTeamSubmitPayload) => Promise<void>;
  };

export function TransferCallsheetDialog({
  callsheetName,
  callsheetCount,
  ...props
}: TransferCallsheetDialogProps) {
  const { t } = useTranslation('callsheets', {
    keyPrefix: 'TransferCallsheetDialog'
  });

  return (
    <TransferToTeamDialog
      {...props}
      titleMessage={t('title')}
      descriptionMessage={t('description', {
        count: callsheetCount,
        name: callsheetName
      })}
      fieldWorkspaceMessage={t('fieldWorkspace')}
      fieldTeamMessage={t('fieldTeam')}
    />
  );
}
